import React, { useState, useEffect } from 'react'
import { Table, Icon, IconButton, Row, Col } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'

export default function AssetQrCodeReportTable({
  schema,
  loading,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},

  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values || [])
  }, [schema.values])

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 50}
        data={tableData}
        style={{ marginTop: '20px' }}
      >
        <Column width={90} align="center" fixed="left">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              // return index + 1
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCode" />
        </Column>
        <Column minWidth={300} width={300} flexGrow={1}>
          <HeaderCell>คำอธิบาย/ชื่อครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetName" />
        </Column>
        <Column width={250}>
          <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetType" />
        </Column>
        {/* <Column width={180} align="center">
          <HeaderCell>วันที่อนุมัติ</HeaderCell>
          <Cell dataKey="approvedDate" />
        </Column> */}
        <Column width={180} align="center">
          <HeaderCell>QR Code</HeaderCell>
          {/* <Cell dataKey="QrPic" /> */}
          <Cell>
            {(rowData) => {
              var imgSrc = `data:image/png;base64,${rowData.qrCodeImg}`

              return (
                //<div style={{ height: 'auto', width: '100%', textAlign: 'center' }}>
                <img
                  src={rowData.qrCodeImg}
                  alt="QR Code"
                  style={{ width: '30%', minWidth: 70, height: 70 }}
                  //className="contact-img"
                />
                //</div>
              )
            }}
          </Cell>
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
